<template>
    <div class="h-full flex items-center">
        <div class="h-full flex items-center cursor-pointer" @mousedown.stop="jumpAndStartDragging($event)">
            <div class="w-16 bg-gray-500 h-1 flex-grow-1 relative rounded" ref="track"
            >
                <div class="bg-white h-full rounded" :style="{ width: (volume * 100) + '%' }" />
            </div>
        </div>
    </div>
</template>

<script>
    import range from 'lodash/range'
    import { mapGetters, mapState, mapActions } from '@/utils/namespaced-mappings'

    export default {
        props: {
            namespace: { type: String, required: true },
        },

        data() {
            return {
                mouseUpHandler: null,
                mouseMoveHandler: null,
            }
        },

        computed: {
            ...mapState(['volume']),
        },

        mounted() {
            document.addEventListener('mouseup', this.mouseUpHandler = e => {
                this.dragging = false
            })

            document.addEventListener('mousemove', this.mouseMoveHandler = e => {
                if (this.dragging) {
                    this.updateDragging(e.clientX - this.$refs.track.getBoundingClientRect().left)
                }
            })
        },

        beforeDestroy() {
            document.removeEventListener('mouseup', this.mouseUpHandler)
            document.removeEventListener('mousemove', this.mouseMoveHandler)
        },
    
        methods: {
            ...mapActions(['setVolume']),

            jumpAndStartDragging(e) {
                this.dragging = true
                this.updateDragging(e.clientX - this.$refs.track.getBoundingClientRect().left)
            },

            startDragging() {
                this.dragging = true
            },

            updateDragging(offsetX) {
                let fraction = offsetX / this.$refs.track.offsetWidth
                fraction = Math.max(0, fraction)
                fraction = Math.min(1, fraction)

                this.setVolume(fraction)
            },
        },
    }
</script>
